<script>
import CrudListVue from 'Arch/components/crud/CrudList.vue';
import UsersRequest from 'App/users/UsersRequest';
import DataTableDateColumnVue from 'Arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import UserExpandableList from 'App/users/components/tables/UserExpandableList.vue';

export default {
  name: 'UserList',
  extends: CrudListVue,
  data: () => ({
    requestClass: UsersRequest,
    editRoute: 'users.edit',
    showExpand: true,
    hideDelete: true,
    expandComponent: UserExpandableList,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Nome',
        value: 'name',
      },
      {
        text: 'Última atualização',
        value: 'updatedAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
